<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "VoiceAgentDeleted",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.voiceAgentDeleted', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                agentName: this.$_.get(this.activity, 'payload.agentName'),
                agentId: this.$_.get(this.activity, 'payload.agentId')
            });
        }
    }
};
</script>

